import {
  CloseTask,
  CloseTaskCompleted,
  CloseTaskFailed,
} from './task-close.action';
import {
  CreateSurveyTask,
  CreateTask,
  CreateTaskCompleted,
  CreateTaskFailed,
} from './task-create.action';
import {
  LoadTasks,
  LoadTasksCompleted,
  LoadTasksFailed,
  LoadTaskTemplates,
  LoadTaskTemplatesCompleted,
  LoadTaskTemplatesFailed,
} from './task-load.action';
import {
  SelectTask,
  SelectTaskCompleted,
  SelectTaskFailed,
} from './task-select.action';
import {
  UpdateTask,
  UpdateTaskCompleted,
  UpdateTaskFailed,
} from './task-update.action';

export { CloseTask, CloseTaskCompleted, CloseTaskFailed } from './task-close.action';
export { TaskActionType } from './task-action-type.enum';
export { CreateSurveyTask, CreateTask, CreateTaskCompleted, CreateTaskFailed } from './task-create.action';
export { LoadTasks,
         LoadTasksCompleted,
         LoadTasksFailed,
         LoadTaskTemplates,
         LoadTaskTemplatesCompleted,
         LoadTaskTemplatesFailed } from './task-load.action';
export { UpdateTask, UpdateTaskCompleted, UpdateTaskFailed } from './task-update.action';
export { SelectTask, SelectTaskCompleted, SelectTaskFailed } from './task-select.action';

export type TaskActions =

  CreateTask |
  CreateSurveyTask |
  CreateTaskCompleted |
  CreateTaskFailed |

  LoadTasks |
  LoadTasksCompleted |
  LoadTasksFailed |

  CloseTask |
  CloseTaskCompleted |
  CloseTaskFailed |

  LoadTaskTemplates |
  LoadTaskTemplatesCompleted |
  LoadTaskTemplatesFailed |

  UpdateTask |
  UpdateTaskCompleted |
  UpdateTaskFailed |

  SelectTask |
  SelectTaskCompleted |
  SelectTaskFailed;
